export class AppSettings {
    static timeZone = 'timezone';
    static menuLayout = 'menuLayout';
    static menuTheme = 'menuTheme';
    static appTheme = 'appTheme';
    static topBarColor = 'topBarColor';
}
